import api from './api';

export const authService = {
  // Sync our app's user row with Supabase auth (call after every Supabase login)
  sync: (data) => api.post('/auth/sync', data || {}).then((r) => r.data.user),
  me: () => api.get('/auth/me').then((r) => r.data.user),
  updateMe: (data) => api.patch('/auth/me', data).then((r) => r.data.user),
  changePassword: (data) => api.patch('/auth/me/password', data).then((r) => r.data),
};

export const profileService = {
  get: () => api.get('/profile').then((r) => r.data.profile),
  upsert: (data) => api.put('/profile', data).then((r) => r.data),
};

export const goalService = {
  list: (params) => api.get('/goals', { params }).then((r) => r.data.goals),
  get: (id) => api.get(`/goals/${id}`).then((r) => r.data.goal),
  create: (data) => api.post('/goals', data).then((r) => r.data.goal),
  update: (id, data) => api.patch(`/goals/${id}`, data).then((r) => r.data.goal),
  delete: (id) => api.delete(`/goals/${id}`).then((r) => r.data),
  complete: (id) => api.post(`/goals/${id}/complete`).then((r) => r.data.goal),
};

export const planService = {
  list: () => api.get('/plans').then((r) => r.data.plans),
  get: (id) => api.get(`/plans/${id}`).then((r) => r.data.plan),
  generate: (data) => api.post('/plans/generate', data).then((r) => r.data.plan),
  regenerate: (id) => api.post(`/plans/${id}/regenerate`).then((r) => r.data.plan),
  getProgress: (id) => api.get(`/plans/${id}/progress`).then((r) => r.data),
  logProgress: (id, data) => api.post(`/plans/${id}/progress`, data).then((r) => r.data.entry),
  deleteProgress: (planId, entryId) => api.delete(`/plans/${planId}/progress/${entryId}`).then((r) => r.data),
};

export const dashboardService = {
  get: () => api.get('/dashboard').then((r) => r.data),
};

export const transactionService = {
  list: (year, month) => api.get('/transactions', { params: { year, month } }).then((r) => r.data),
  listYear: (year) => api.get('/transactions', { params: { year } }).then((r) => r.data),
  availableYears: () => api.get('/transactions/years').then((r) => r.data.years),
  create: (data) => api.post('/transactions', data).then((r) => r.data.transaction),
  delete: (id) => api.delete(`/transactions/${id}`).then((r) => r.data),
};

export const subscriptionService = {
  getStatus: () => api.get('/subscription').then((r) => r.data),
  checkout: (data) => api.post('/subscription/checkout', data).then((r) => r.data),
  portal: (data) => api.post('/subscription/portal', data).then((r) => r.data),
};

export const pricingService = {
  getByCurrency: (currency) =>
    api.get('/pricing', { params: { currency } }).then((r) => r.data.pricing),
};

export const debtService = {
  list:         ()       => api.get('/debt').then((r) => r.data.goals),
  get:          (id)     => api.get(`/debt/${id}`).then((r) => r.data.goal),
  create:       (data)   => api.post('/debt', data).then((r) => r.data.goal),
  update:       (id, d)  => api.patch(`/debt/${id}`, d).then((r) => r.data.goal),
  delete:       (id)     => api.delete(`/debt/${id}`).then((r) => r.data),
  complete:     (id)     => api.post(`/debt/${id}/complete`).then((r) => r.data.goal),
  generatePlan: (id)     => api.post(`/debt/${id}/plan`).then((r) => r.data.plan),
  getPlan:      (id)     => api.get(`/debt/${id}/plan`).then((r) => r.data),
};

